/* PackLite Pass 6 (staging) · product template, phone only (<=749px); /cart Chat overlap gate, all widths. No cart logic, no prices.
   C6: sticky ATC visible whenever the main ATC is not FULLY on screen; hidden only while it is fully on screen.
   C7: Chat button hidden until the Buy Box selling points have scrolled past; then sits 12px above the sticky bar.
   Never hides chat while it is open/focused/expanded. Motion handled in CSS (reduced-motion = instant). */
(function () {
  'use strict';
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var CHAT_GAP = 12; /* Designer C7: 12px above the sticky bar */
  var CHAT_SEL = 'shopify-chat, #shopify-chat, #dummy-chat-button-iframe, iframe[name="chat-button"]';

  /* Oct 8 hardening: Shopify's <shopify-chat> now renders a placeholder button.activator in its own shadow root for ~0.6s,
     then swaps to <shopify-agent-runtime> whose activator lives in a NESTED shadow root, while the host becomes a
     full-viewport fixed layer. Find the activator through open shadow roots (bounded), never fall back to the host box. */
  var actCache = null;
  function findActivator() {
    if (actCache && actCache.isConnected) return actCache;
    actCache = null;
    var h = document.querySelector('shopify-chat');
    if (!h || !h.shadowRoot) return null;
    var q = [h.shadowRoot], seen = 0;
    while (q.length && seen < 40) {
      var r = q.shift(); seen++;
      var a = r.querySelector('button.activator, [part~="activator"]');
      if (a) { actCache = a; return a; }
      var all = r.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) if (all[i].shadowRoot) q.push(all[i].shadowRoot);
    }
    return null;
  }
  /* Chat button box: activator; legacy iframe button; or the host only while it is button-sized (old widget). Else null = no gate (fail open). */
  function chatBox() {
    var a = findActivator();
    if (a) { var ar = a.getBoundingClientRect(); if (ar.height > 0) return ar; }
    var f = document.querySelector('#dummy-chat-button-iframe, iframe[name="chat-button"]');
    if (f) { var fr = f.getBoundingClientRect(); if (fr.height > 0 && fr.height <= 160) return fr; }
    var h = document.querySelector('shopify-chat');
    if (h) { var hr = h.getBoundingClientRect(); if (hr.height > 0 && hr.height <= 160 && hr.width <= 320) return hr; }
    return null;
  }

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var bar = document.getElementById('PackliteStickyAtc');
    var info = document.querySelector('[id^="ProductInfo-"]');
    /* Scope by Liquid template.name (data attribute on this script tag), never by DOM match: homepage featured-product blocks are untouched. */
    var tplEl = document.querySelector('script[data-pl6-template]');
    var tpl = tplEl ? tplEl.getAttribute('data-pl6-template') : '';
    if (tpl === 'cart') { cartGate(); return; }
    if (tpl !== 'product' || !info) return;

    /* P6 add-on: /cart, ALL widths (Auditor rule). Chat is faded (opacity 0 + pointer-events none, NEVER visibility/display, so it stays
       keyboard-focusable and shows on focus) ONLY while its box intersects the wallet-button row, and never at the page bottom or while engaged. */
    function cartGate() {
      var WSEL = '#main-cart-footer .cart__dynamic-checkout-buttons';
      if (!document.querySelector(WSEL)) return;
      var b = document.body;
      b.classList.add('pl6-chatgate');
      function up() {
        var w = document.querySelector(WSEL); /* re-query: survives section re-renders */
        if (!w) { b.classList.remove('pl6-chat-overlap'); return; }
        var c = chatBox(), r = w.getBoundingClientRect();
        var atBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 2;
        var hit = !!c && c.height > 0 && r.height > 0 && c.left < r.right && c.right > r.left && c.top < r.bottom && c.bottom > r.top;
        b.classList.toggle('pl6-chat-overlap', hit && !atBottom && !engaged());
      }
      var tk = false;
      window.addEventListener('scroll', function () { if (!tk) { tk = true; requestAnimationFrame(function () { tk = false; up(); }); } }, { passive: true });
      ['resize', 'load', 'focus'].forEach(function (e) { window.addEventListener(e, up); });
      document.addEventListener('focusin', up, true);
      document.addEventListener('focusout', function () { setTimeout(up, 0); }, true);
      new MutationObserver(up).observe(b, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
      /* wallet buttons and the chat widget render late (shadow DOM, no light-DOM mutation): watch their size, plus timed rechecks */
      if (window.ResizeObserver) {
        var ro = new ResizeObserver(up);
        ro.observe(document.querySelector(WSEL));
        var hostEl = document.querySelector('shopify-chat'); if (hostEl) ro.observe(hostEl);
      }
      [250, 750, 1500, 3000, 6000].forEach(function (t) { setTimeout(up, t); });
      up();
    }
    var mainAtc = info.querySelector('.product-form__submit');
    var points = info.querySelector('[id*="buy_box_selling_points"]');
    var body = document.body;
    body.classList.add('pl6-pdp');

    function isPhone() { return !MQ || MQ.matches; }

    function engaged() {
      var els = document.querySelectorAll(CHAT_SEL);
      var ae = document.activeElement;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.hasAttribute('open')) return true;
        if (ae && (ae === el || el.contains(ae))) return true;
        try { if (el.matches(':focus-within')) return true; } catch (e) {}
        if (el.tagName === 'IFRAME' && el.getBoundingClientRect().height > 120) return true;
      }
      return false;
    }

    function setSticky(on) {
      if (!bar) return;
      bar.classList.toggle('pl6-sticky-off', !on);
      if (on) { bar.removeAttribute('aria-hidden'); bar.removeAttribute('inert'); }
      else { bar.setAttribute('aria-hidden', 'true'); bar.setAttribute('inert', ''); }
    }

    var measuredFor = null; /* activator element the current offset was measured on (placeholder vs runtime differ by ~8px) */
    function positionChat() {
      if (!isPhone() || !bar) { body.classList.remove('pl6-chat-pos'); return; }
      var host = document.querySelector('shopify-chat');
      if (!host) return;
      var btn = findActivator();
      if (!btn) return;
      var hr = host.getBoundingClientRect();
      var br = btn.getBoundingClientRect();
      if (!br.height) return;
      measuredFor = btn;
      var inner = Math.round(hr.bottom - br.bottom); /* widget's own offset inside its host */
      var barH = bar.offsetHeight || 0;
      var bottom = Math.max(0, barH + CHAT_GAP - inner);
      document.documentElement.style.setProperty('--pl6-chat-bottom', bottom + 'px');
      body.classList.add('pl6-chat-pos');
    }

    function update() {
      if (isPhone()) { var a0 = findActivator(); if (a0 && a0 !== measuredFor) positionChat(); } /* widget swapped its activator: re-measure */
      if (!isPhone()) {
        setSticky(true);
        body.classList.remove('pl6-chat-wait', 'pl6-chat-engaged');
        return;
      }
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (mainAtc) {
        var r = mainAtc.getBoundingClientRect();
        /* Auditor #4: sticky stays on until the main ATC is FULLY on screen (no partial-visibility gap) */
        var fully = r.height > 0 && r.top >= 0 && r.bottom <= vh;
        setSticky(!fully);
      }
      var eng = engaged();
      body.classList.toggle('pl6-chat-engaged', eng);
      if (points) {
        var pr = points.getBoundingClientRect();
        body.classList.toggle('pl6-chat-wait', !(pr.bottom < 0));
      }
    }

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () { ticking = false; update(); });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { update(); positionChat(); });
    window.addEventListener('load', function () { update(); positionChat(); });
    document.addEventListener('focusin', update, true);
    document.addEventListener('focusout', function () { setTimeout(update, 0); }, true);
    window.addEventListener('blur', function () { setTimeout(update, 0); });

    /* chat widget mounts late: watch for it, then measure + watch its open state */
    var mo = new MutationObserver(update);
    function watchChat() {
      var els = document.querySelectorAll(CHAT_SEL);
      for (var i = 0; i < els.length; i++) {
        if (els[i].__pl6) continue;
        els[i].__pl6 = true;
        mo.observe(els[i], { attributes: true, attributeFilter: ['open', 'style', 'class', 'height'] });
      }
      positionChat();
    }
    new MutationObserver(watchChat).observe(body, { childList: true });
    watchChat();
    var tries = 0;
    /* keep re-measuring for ~20s (and on any activator swap, see update()): the widget swaps its placeholder activator for the runtime one after load */
    var iv = setInterval(function () { positionChat(); if (++tries > 40) clearInterval(iv); }, 500);
    update();
  });
})();
